import { Button } from "../uikit";
import SupportIcon from "../img/support.svg";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export default function SupportButton() {
  const { t, _ } = useTranslation();

  const navigate = useNavigate();
  return (
    <Button
      mode="gray"
      size="l"
      before={<img src={SupportIcon} alt="" className="monochrome-icon" />}
      onClick={() => navigate('/account/support')}
    >
      {t("Support")}
    </Button>
  );
}
